exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--3IUDVEkQhL27QVSGVxubAr {\n  border-top: 1px solid #6dc4e5;\n  border-bottom: 1px dotted #6dc4e5;\n  padding: 10px 0 8px;\n  margin-bottom: 15px;\n}\n\n.PatientConsentForMedicalRecordsExchange--VZnviLoRwozpP0RerSFbQ {\n  display: flex;\n  justify-content: space-between;\n}\n\n.PatientConsentForMedicalRecordsExchange--3vi4WO8alasYFKIPhyBTKS {\n  color: #244861;\n  text-transform: capitalize;\n  font-weight: bold;\n  font-size: 1.3em;\n}\n", ""]);

// exports
exports.locals = {
	"patientConsentLines": "PatientConsentForMedicalRecordsExchange--3IUDVEkQhL27QVSGVxubAr",
	"patientConsentLines": "PatientConsentForMedicalRecordsExchange--3IUDVEkQhL27QVSGVxubAr",
	"patientConsentHeader": "PatientConsentForMedicalRecordsExchange--VZnviLoRwozpP0RerSFbQ",
	"patientConsentHeader": "PatientConsentForMedicalRecordsExchange--VZnviLoRwozpP0RerSFbQ",
	"patientConsentHeaderText": "PatientConsentForMedicalRecordsExchange--3vi4WO8alasYFKIPhyBTKS",
	"patientConsentHeaderText": "PatientConsentForMedicalRecordsExchange--3vi4WO8alasYFKIPhyBTKS"
};